import { TrackingEventsV2 } from '@/analytics/eventsV2';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { Icon } from '@/new/components/icon';

export enum ViewMode {
  Table = 'table',
  Visual = 'visual',
}

export function ViewSelector({
  viewMode,
  onViewModeChange,
}: {
  viewMode: ViewMode;
  onViewModeChange: (viewMode: ViewMode) => void;
}) {
  return (
    <div className="flex h-8 rounded border bg-white">
      <button
        onClick={() => onViewModeChange(ViewMode.Table)}
        className={`flex items-center gap-1 rounded-l px-3 py-2 text-xs font-medium transition-colors duration-200 ${
          viewMode === ViewMode.Table ? 'bg-blue-500 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'
        }`}
        title="Table View"
      >
        <Icon className="lucide--chart-gantt" />
        Timeline
      </button>
      <button
        onClick={() => {
          trackCustomEvent(TrackingEventsV2.ChronologySwitchToVisual);
          onViewModeChange(ViewMode.Visual);
        }}
        className={`flex items-center gap-1 rounded-r px-3 py-2 text-xs font-medium transition-colors duration-200 ${
          viewMode === ViewMode.Visual ? 'bg-blue-500 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'
        }`}
        title="Visualisation View"
      >
        <Icon className="lucide--waypoints" />
        Visual
      </button>
    </div>
  );
}
